import { Box, FormControl, MenuItem, Select, Tooltip } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import MultiQtyCell from "../../components/dms_common/MultiQtyCell";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { viewManageOrderRowsData } from "../viewOrder/ViewOrderType";
import { ReactComponent as CircledRight } from "../../assets/image/svg/circledRight.svg";
import { UOM } from "../createSecondaryOrder/CreateSecondaryOrderType";
import { ReactComponent as DisclaimerIcon } from "../../assets/image/svg/disclaimer.svg";
import { ReactComponent as EncircledDisclaimerIcon } from "../../assets/image/svg/encircledDisclaimer.svg";
import { calculateFinalStock, createSkuWiseStockMapForBatchId, getBatchCodeQuantities, getBatchCodes, getBatchCodesWithoutFreeItem, getSkuToMinExpiryBatch, getSkuToNameCodeMap, getSkuToReplacementSkuMap, ordersWithStockExceedingWarning, SkuExpiryInfo } from "../viewOrder/ViewOrderUtils";
import { ReactComponent as SubtractIcon } from "../../assets/image/svg/subtractIcon.svg";
import { getQuantityType, TruncatedTextUptoLine, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { performUomConversion } from "../../services/catalogueService";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import { getOutletDetails } from "../createSecondaryOrder/CreateSecondaryOrderService";
import { OutletDetails } from "../createSecondaryOrder/models";
import { fetchBatchDataForSkuList } from "../stocks/RealTimeStock/RealTimeStockUtils";
import { getDataFromLocalDb } from "../../services/dbService";
import { getCreditData, sendBulkInvoicingAfterManualAllocation } from "../../services/manageOrderService";
import { batch } from "react-redux";
import { ChannelkartNetworkGet, ChannelkartNetworkPut } from "../../services/networkService";
import { string } from "yup";
import { sum } from "lodash";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";

let currency: string = "",
  caseUnitLabel: string = "",
  otherUnitLabel: string = "",
  packUnitLabel: string = "";

export const setAndGetViewOrderEditTableHeader = (ConfigDictionary: any, primaryOrder: boolean = false) => {
  caseUnitLabel = primaryOrder ? ConfigDictionary?.caseUnitLabelPrimary : ConfigDictionary?.caseUnitLabel;
  otherUnitLabel = primaryOrder ? ConfigDictionary?.otherUnitLabelPrimary : ConfigDictionary?.otherUnitLabel;
  packUnitLabel = primaryOrder ? ConfigDictionary?.packUnitLabelPrimary : ConfigDictionary?.packUnitLabel;
  currency = ConfigDictionary?.currency;

  return {
    SKUCODE: "SKU Code",
    PROMOTION: "Promotion",
    PIECEPRICE: `Price (Each ${packUnitLabel})`,
    AMOUNT: "Amount",
    DISCOUNT: "Discount",
    FINALAMOUNT: "Final Amount",
    PIECEQUANTITY: `QTY (${packUnitLabel})`,
    CASEQUANTITY: `QTY (${caseUnitLabel})`,
    OTHERQUANTITY: `QTY (${otherUnitLabel})`,
    SKUNAME: "SKU Name",
    CASEPRICE: `Price (Each ${caseUnitLabel})`,
    CATEGORY: "Category",
  };
};

export const checkIfStockExceeded = (
  caseQty: number,
  otherQty: number,
  pieceQty: number,
  caseStock: number,
  otherStock: number,
  pieceStock: number,
  caseToPieceQty: number,
  otherToPieceQty: number,
  type?: UOM
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  if (ConfigDictionary.uomConversion) {
    const normalizedQty = caseQty * caseToPieceQty + otherQty * otherToPieceQty + pieceQty;
    const normalizedStock = caseStock * caseToPieceQty + otherStock * otherToPieceQty + pieceStock;
    return normalizedQty > normalizedStock;
  }

  const qty = type === UOM.CASE ? caseQty : type === UOM.OTHER ? otherQty : pieceQty;
  const stock = type === UOM.CASE ? caseStock : type === UOM.OTHER ? otherStock : pieceStock;
  return qty > stock;
};

export const checkIfQtyBelowMOQ = (
  caseQty: number,
  otherQty: number,
  pieceQty: number,
  caseToPieceQty: number,
  otherToPieceQty: number,
  minimumOrderQuantity: number,
  type?: UOM
) => {
  const normalizedQty = caseQty * caseToPieceQty + otherQty * otherToPieceQty + pieceQty;
  return normalizedQty < minimumOrderQuantity;
};


export const getMetaData1 = (sortOversold: () => void): any[] => {
  // Build the label for totalQuantities based on truthy labels
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  caseUnitLabel = ConfigDictionary?.caseUnitLabel;
  otherUnitLabel = ConfigDictionary?.otherUnitLabel;
  packUnitLabel = ConfigDictionary?.packUnitLabel;
  currency = ConfigDictionary?.currency;
  const availableLabels = [];
  if (caseUnitLabel) availableLabels.push(caseUnitLabel);
  if (otherUnitLabel) availableLabels.push(otherUnitLabel);
  if (packUnitLabel) availableLabels.push(packUnitLabel);
  const totalQuantitiesMeta = availableLabels.length > 0
  ? [{
      keys: "totalOrderedQuantities",
      label: `Total Ordered Quantity`,
      index: 2,
      valueType: "Array",
      render: "Jsx",
    }]
  : []; 
  const totalOverSoldMeta = availableLabels.length > 0
  ? [{
      keys: "stockExceedingQuantity",
      label: `Oversold Quantity`,
      index: 2,
      valueType: "Array",
      render: "Jsx",
      customStyles: {
        color: "#B54747",
        cursor: "pointer"
      },
      onClick: sortOversold
    }]
  : []; 

  const metaData = [
    {
      keys: "totalOrders",
      label: "Total Orders",
      index: 1,
      valueType: "Number",
    },
    {
      keys: "totalSKUs",
      label: "Total SKUs",
      index: 4,
      valueType: "Number",
    },
    {
      keys: "keyAccounts",
      label: "Key Accounts",
      index: 4,
      valueType: "Number",
    },
    ...totalQuantitiesMeta,
    ...totalOverSoldMeta
  ];

  // Filter out metadata entries whose keys are in the excludeKeys array
  return metaData;
};

interface OutletInfo {
  outletCode: string;
  outletName: string;
  isKeyAccount: boolean;
}



export type SkuToOrderMapping = Record<string, SkuOrderMappingEntry>;

export type GlobalNormalizedStockMap = Map<string, GlobalStockMapRecord>; 

export interface SkuOrderMappingEntry {
  order: any[]; // You can replace `any` with a proper Order type if available
  orderedQuantity: number;
  allocatedQuantity: number;
  stockQuantityExceeding: number;
  availableQuantity: number;
  outletList: OutletInfo[];
  minExpiryDate?: Date;           // optional, if using expiry info
  batchWithMinExpiry?: string;    // optional, batchId with min expiry
  skuName?: string;
  skuCode?: string;
  replacementSku?: Record<string, [number, number, number]>;
}

export interface StockAllocationRowData {
  id: string;
  skuCode: string;
  skuName: string;
  batchName: string;
  batchCode: string;
  batchId: string;
  // now a list of outlets for the SKU (one row per SKU)
  outletList: OutletInfo[];

  totalOrderedQuantity: number;
  orderedCases: number;
  orderedPieces: number;
  orderedOthers: number;

  totalAvailableQuantity: number;
  availableCases: number;
  availablePieces: number;
  availableOthers: number;

  totalAllocatedQuantity: number;
  allocatedCases: number;
  allocatedPieces: number;
  allocatedOthers: number;

  totalStockExceedingQuantity: number;
  stockExceedingCases: number;
  stockExceedingPieces: number;
  stockExceedingOthers: number;
  stockQuantityExceed?:boolean;
  finalValue: number;
  status: string;
  allocationMethod?: string;
  hasCompletedAllocation?:boolean;
  showEditIcon: boolean;
  minExpiryDate?: Date;
  order: any[];
  totalReplacementCases: number;
  totalReplacementPieces: number;
  totalReplacementOthers: number;
  replacementSkuList: string[];
  replacementSkuAllocated: Record<string, [cs: number, pi: number, oth: number]>;
  replacementSkuAvailable: Record<string, [number, number, number]>;
  mainSkuTotalAvailableQuantity: number;
  mainSkuAvailableCases: number;
  mainSkuAvailablePieces: number;
  mainSkuAvailableOther: number;
}

export async function buildStockAllocationData(
  selectedOrders: any[],
  globalNormalizedStockMap: GlobalNormalizedStockMap,
  orderUomCheck: string
): Promise<StockAllocationRowData[]> {

  const rows: StockAllocationRowData[] = [];
  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};
  const addToUomWiseAllocation = (sku: string, normalizedQty: number) => {
    const product = products[sku];
    if (!product || normalizedQty === 0) return { cs: 0, pi: 0, oth: 0 };

    let { caseToPieceQuantity, otherUnitToPieceQuantity, uom, otherUnitName } = product;
    if (orderUomCheck === "true") uom = product?.uom ?? "all";
    else uom = "all";

    const { convertedCaseQty, convertedOtherQty, convertedPieceQty } =
      performUomConversion(
        0,
        0,
        normalizedQty,
        uom,
        caseToPieceQuantity,
        otherUnitToPieceQuantity,
        0,
        0,
        0,
        true,
        otherUnitName
      );

    return { cs: convertedCaseQty, pi: convertedPieceQty, oth: convertedOtherQty };
  };
  let batchCodeMap: OrderNumberBatchCodesMapType = {};
  let allBatchCodesSet: Set<string> = new Set();
  for (const ro of selectedOrders) {
    const orderedBatchCodes: string =
    getBatchCodesWithoutFreeItem(ro["orderDetails"] ?? "") ?? "";
    const orderNumber = ro.orderNumber;
    batchCodeMap[orderNumber] = orderedBatchCodes;
    
    // Split batch codes and add to the Set to ensure uniqueness
    const codesArray = orderedBatchCodes
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
    codesArray.forEach((code) => allBatchCodesSet.add(code));
  }
  globalNormalizedStockMap.forEach((mapping, batchCode) => {
    if (!allBatchCodesSet.has(batchCode)) return;
    const product = products[batchCode] ?? {};
    // stock map provides [cases, pieces, others]

    const replacementSkuAllocated = mapping.replacementSkuAllocated as Record<string, Record<string, number>>;


    const replacementSkuSummary: Record<string, number> = {};

    for (const orderAllocations of Object.values(replacementSkuAllocated)) {
      // orderAllocations: Record<sku, qty>
      for (const [sku, qty] of Object.entries(orderAllocations)) {
        replacementSkuSummary[sku] = (replacementSkuSummary[sku] || 0) + (Number(qty) || 0);
      }
    }

    const uomWiseReplacementSkuSummary: Record<string, [number, number, number]> = {};

    for (const [sku, totalQty] of Object.entries(replacementSkuSummary)) {

      const { cs: convertedCaseQty, oth: convertedOtherQty , pi: convertedPieceQty} = addToUomWiseAllocation(
        sku,
        totalQty,
      );

      uomWiseReplacementSkuSummary[sku] = [convertedCaseQty, convertedPieceQty, convertedOtherQty];
    }

    const uomWiseReplacementSkuAvailableSummary: Record<string, [number, number, number]> = {};

    for (const repl of mapping.replacementSku) {
      const curr = globalNormalizedStockMap.get(repl);
      let stock = curr?.remainingReplacementQuantity ?? 0;
      let totalAllocated = 0;
      let somethingElse = 0;

      // mapping.replacementSkuAllocated is Record<orderId, Record<sku, qty>>
      for (const orderId in mapping.replacementSkuAllocated) {
        const allocatedByOrder = mapping.replacementSkuAllocated[orderId];
        for (const [allocatedSku, qty] of Object.entries(allocatedByOrder)) {
          if (allocatedSku === repl) {
            stock += qty;
            totalAllocated += qty;
          }
        }
      }
      const stockBreakdown = addToUomWiseAllocation(repl, stock)
      uomWiseReplacementSkuAvailableSummary[repl] = [stockBreakdown.cs, stockBreakdown.oth, stockBreakdown.pi];
    }

    let replacementsAllocated = 0;
    for (const inner of Object.values(replacementSkuAllocated)) {
      for (const qty of Object.values(inner)) {
        replacementsAllocated += Number(qty) || 0;
      }
    }

    const unAllocatedReplacementsQty = mapping.replacementSku.reduce((sum: number, repl: string) => {
      const curr = globalNormalizedStockMap.get(repl);
      return sum + (curr?.remainingReplacementQuantity ?? 0);
    }, 0);

    const totalOrdered = mapping.totalOrderedQuantity ?? 0;

    const totalAllocated = (mapping.mainAllocatedQuantity ?? 0) + replacementsAllocated;

    const totalExceeding = totalOrdered - totalAllocated;


    const orderedBreakdown = addToUomWiseAllocation(batchCode, totalOrdered);
    const exceedingBreakdown = addToUomWiseAllocation(batchCode, totalExceeding);

    //total allocated quantity by uom
    const allocatedBreakdownForCurrentSku = addToUomWiseAllocation(batchCode, mapping.mainAllocatedQuantity ?? 0);

    let totalReplacementAllocatedCases = 0;
    let totalReplacementAllocatedPieces = 0;
    let totalReplacementAllocatedOthers = 0;
    let totalReplacementAllocated = 0

    for (const orderId in replacementSkuAllocated) {
      const orderMap = replacementSkuAllocated[orderId]; // Record<replacementSku, quantity>
      for (const repl of Object.keys(orderMap)) {
        const qty = orderMap[repl] ?? 0;
        totalReplacementAllocated += qty
        const breakDown = addToUomWiseAllocation(repl, qty);

        totalReplacementAllocatedCases += breakDown.cs;
        totalReplacementAllocatedPieces += breakDown.pi;
        totalReplacementAllocatedOthers += breakDown.oth;
      }
    }

    const totalAvailable = mapping.totalAvailableQuantity - mapping.allocatedReplacementQuantity + unAllocatedReplacementsQty + totalReplacementAllocated;

    //total available quantity by uom
    const availableBreakdownForCurrentSku = addToUomWiseAllocation(batchCode, mapping?.totalAvailableQuantity ?? 0) 

    const allocatedBreakdown = addToUomWiseAllocation(batchCode, mapping.mainAllocatedQuantity + totalReplacementAllocated)

    let totalReplacementCases = 0;
    let totalReplacementPieces = 0;
    let totalReplacementOthers = 0;

    mapping.replacementSku.forEach((repl) => {
      const currStock = globalNormalizedStockMap.get(repl)?.remainingReplacementQuantity ?? 0;
      const breakDown = addToUomWiseAllocation(repl, currStock);

      totalReplacementCases += breakDown.cs;
      totalReplacementPieces += breakDown.pi;
      totalReplacementOthers += breakDown.oth;
    });

    const availableBreakdown = addToUomWiseAllocation(batchCode, totalAvailable)

    const mainAvailableBreakdown = addToUomWiseAllocation(batchCode, mapping.totalAvailableQuantity - mapping.allocatedReplacementQuantity )

    // status logic
    let status = "Out of stock";
    if (totalAllocated === 0) status = "Out of stock";
    else if (totalAllocated < totalOrdered) status = "Partially allocated";
    else status = "Fully allocated";

    rows.push({
      id: batchCode,
      skuCode: product.skuCode ?? "",
      skuName: product.skuDescription ?? "",
      batchName: product.batchName ?? "",
      batchCode,
      batchId: mapping.batchWithMinExpiry ?? "unassigned",
      outletList: mapping.outletList ?? [],

      totalOrderedQuantity: totalOrdered,
      orderedCases: orderedBreakdown.cs,
      orderedPieces: orderedBreakdown.pi,
      orderedOthers: orderedBreakdown.oth,

      totalAvailableQuantity: totalAvailable,
      availableCases: availableBreakdown.cs,
      availablePieces: availableBreakdown.pi,
      availableOthers: availableBreakdown.oth,

      totalAllocatedQuantity: totalAllocated,
      allocatedCases: allocatedBreakdown.cs,
      allocatedPieces: allocatedBreakdown.pi,
      allocatedOthers: allocatedBreakdown.oth,

      totalStockExceedingQuantity: totalExceeding,
      stockExceedingCases: exceedingBreakdown.cs,
      stockExceedingPieces: exceedingBreakdown.pi,
      stockExceedingOthers: exceedingBreakdown.oth,
      stockQuantityExceed: (totalOrdered > totalAvailable),
      showEditIcon: mapping.showEditIcon ?? false,
      finalValue: 0, // adjust currency/precision as needed
      status,
      allocationMethod: mapping.allocationMethod ?? "FIFO",
      hasCompletedAllocation: mapping.hasCompletedAllocation ?? false,
      minExpiryDate: mapping.minExpiryDate,
      order: mapping.orders,
      totalReplacementCases,
      totalReplacementPieces,
      totalReplacementOthers,
      replacementSkuList: mapping.replacementSku,
      replacementSkuAllocated:  uomWiseReplacementSkuSummary,
      replacementSkuAvailable: uomWiseReplacementSkuAvailableSummary,
      mainSkuTotalAvailableQuantity: mapping.totalAvailableQuantity - mapping.allocatedReplacementQuantity,
      mainSkuAvailableCases: mainAvailableBreakdown.cs,
      mainSkuAvailablePieces: mainAvailableBreakdown.pi,
      mainSkuAvailableOther: mainAvailableBreakdown.oth,
    });
  });

  return rows;
}


export const getOutletWiseAllocationAccordianMetadata = (): any[] => {
  // Build the label for totalQuantities based on truthy labels
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  caseUnitLabel = ConfigDictionary?.caseUnitLabel;
  otherUnitLabel = ConfigDictionary?.otherUnitLabel;
  packUnitLabel = ConfigDictionary?.packUnitLabel;
  currency = ConfigDictionary?.currency;
  const availableLabels = [];
  if (caseUnitLabel) availableLabels.push(caseUnitLabel);
  if (otherUnitLabel) availableLabels.push(otherUnitLabel);
  if (packUnitLabel) availableLabels.push(packUnitLabel);



  const totalQuantitiesMeta = availableLabels.length > 0
  ? [{
      keys: "totalOrderedQuantities",
      label: `Total Ordered Quantity`,
      index: 3,
      valueType: "Array",
      render: "Jsx",
    }]
  : []; 
  const totalOverSoldMeta = availableLabels.length > 0
  ? [{
      keys: "stockExceedingQuantity",
      label: `Shortfall Quantity`,
      index: 4,
      valueType: "Array",
      render: "Jsx",
      customStyles: {
        color: "#B54747"
      },
    }]
  : []; 

  const totalAvailableQuantity = availableLabels.length > 0
  ? [{
      keys: "totalAvailableQuantity",
      label: `Available Quantity`,
      index: 5,
      valueType: "Array",
      render: "Jsx",
    }]
  : []; 

  const totalReplacementAvailable = availableLabels.length > 0
  ? [{
      keys: "totalReplacementAvailable",
      label: `Replaced SKU`,
      index: 6,
      valueType: "Array",
      render: "Jsx",
    }]
  : []; 

  const metaData = [
    { 
      keys: "totalOutlets", 
      label: "Total outlets", 
      index: 1,
      valueType: "Number"
    },
    { 
      keys: "keyAccounts", 
      label: "Key accounts", 
      index: 2,
      valueType: "Number"
    },
    ...totalQuantitiesMeta,
    ...totalAvailableQuantity,
    ...totalReplacementAvailable,
    ...totalOverSoldMeta,
  ]

  // Filter out metadata entries whose keys are in the excludeKeys array
  return metaData;
};

const getSkuToOrderMapping = (orders: any[], outletData: OutletDetails[]) => {
  const skuToOrderMapping: SkuToOrderMapping = {};

  orders.forEach((order) => {
    if (!order?.orderDetails || !Array.isArray(order.orderDetails)) {
      console.warn(`Order ${order.id || order.orderNumber || "unknown"} has no valid orderDetails`);
      return;
    }

    order.orderDetails.forEach((orderDetail: any) => {
      // Skip freeItems
      if (orderDetail?.type === "freeItem") return;

      const batchCode = (orderDetail?.batchCode ?? "").trim();
      if (!batchCode) {
        console.warn(`OrderDetail missing batchCode:`, orderDetail);
        return;
      }

      // Initialize mapping if not present
      if (!skuToOrderMapping[batchCode]) {
        skuToOrderMapping[batchCode] = { 
          order: [], 
          orderedQuantity: 0, 
          allocatedQuantity: 0, 
          stockQuantityExceeding: 0, 
          availableQuantity: 0, 
          outletList: [] 
        };
      }

      // Avoid duplicate orders
      const orderExists = skuToOrderMapping[batchCode].order.some(
        (existingOrder) => existingOrder.id === order.id
      );
      if (!orderExists) {
        skuToOrderMapping[batchCode].order.push(order);
      }

      // Add unique outlets
      const outletCode = order?.outletCode ?? "";
      const outletName = order?.outletName ?? "";
      const outletExists = skuToOrderMapping[batchCode].outletList.some(
        (o) => o.outletCode === outletCode
      );
      if (outletCode && outletName && !outletExists) {
        const isKeyAccount = outletData.find((outlet) => outlet.outletCode === outletCode)?.keyAccount ?? false
        skuToOrderMapping[batchCode].outletList.push({ outletCode, outletName, isKeyAccount });
      }
    });
  });

  return skuToOrderMapping;
};

const addOutletInfo = (orders: any[], globalNormalizedStockMap:Map<string, GlobalStockMapRecord>, outletData: OutletDetails[]) => {
  orders.forEach((order) => {
    if (!order?.orderDetails || !Array.isArray(order.orderDetails)) {
      console.warn(`Order ${order.id || order.orderNumber || "unknown"} has no valid orderDetails`);
      return;
    }
    order.orderDetails.forEach((orderDetail: any) => {
      // Skip freeItems
      if (orderDetail?.type === "freeItem") return;

      const batchCode = (orderDetail?.batchCode ?? "").trim();
      if (!batchCode) {
        console.warn(`OrderDetail missing batchCode:`, orderDetail);
        return;
      }

      const curr = globalNormalizedStockMap.get(batchCode)
      if (curr) {
        const outletCode = order?.outletCode ?? ""
        const outletName = order?.outletName ?? ""
        const outletExists = curr?.outletList?.some(
          (o) => o.outletCode === outletCode
        );
        if (outletCode && outletName && !outletExists){
          const isKeyAccount = outletData.find((outlet) => outlet.outletCode === outletCode)?.keyAccount ?? false
          const currOutletList = curr.outletList ?? []
          currOutletList.push({
            outletCode,
            outletName,
            isKeyAccount
          })
          globalNormalizedStockMap.set(batchCode, {
            ...curr,
            outletList: currOutletList
          })
        }
      }
    });
  });

}

type OrderNumberBatchCodesMapType = {
  [key: string]: string
}

export interface GlobalStockMapRecord  {
  totalAvailableQuantity: number;
  totalOrderedQuantity: number;

  mainAllocatedQuantity: number;

  replacementQuantity: number;

  allocatedReplacementQuantity: number;

  remainingReplacementQuantity: number;

  mainAllocatedByOrder: Record<string, number>;
  initialMainAllocatedByOrder: Record<string, number>

  orderedQuantityByOrder: Record<string, number>;

  oversoldQuantity?: number;

  orders: any[]
  replacementSku: string[]

  outletList?: OutletInfo[];
  minExpiryDate?: Date;
  batchWithMinExpiry?: string;
  skuCode?: string;
  skuName?: string;

  //maps order number which contains the current sku to the replacement sku with their code and quantity
  replacementSkuAllocated: Record<string, Record<string, number>>
  hasCompletedAllocation?: boolean;
  allocationMethod?: string;
  showEditIcon?: boolean;
}


export const getGlobalStockMap = async (selectedOrders: any[]): Promise<[GlobalNormalizedStockMap, any[]]> => {
  const globalNormalizedStockMap = new Map<string, GlobalStockMapRecord>();

  let allBatchCodesSet: Set<string> = new Set(); // Use a Set to store unique batch codes
  let batchCodeMap: OrderNumberBatchCodesMapType = {};
  for (const ro of selectedOrders) {
    const orderedBatchCodes: string =
    getBatchCodesWithoutFreeItem(ro["orderDetails"] ?? "") ?? "";
    const orderNumber = ro.orderNumber;
    batchCodeMap[orderNumber] = orderedBatchCodes;
    
    // Split batch codes and add to the Set to ensure uniqueness
    const codesArray = orderedBatchCodes
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
    codesArray.forEach((code) => allBatchCodesSet.add(code));
  }
  let allBatchCodes = Array.from(allBatchCodesSet).join(",");
  
  const { skuToReplacementSkuMap, replacementSkuList } =
      await getSkuToReplacementSkuMap(Array.from(allBatchCodesSet));
  
  const mergedSkuList = Array.from(
    new Set([...Array.from(allBatchCodesSet), ...replacementSkuList])
  ).join(",");

  const BATCH_SIZE = 100;
  const allBatchCodesArray = mergedSkuList
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);

  let stocksData: any[] = [];

  for (let i = 0; i < allBatchCodesArray.length; i += BATCH_SIZE) {
    const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE).join(",");
    const chunkStockData = await fetchBatchDataForSkuList(
      chunk,
      getQuantityType()
    );
    stocksData = stocksData.concat(chunkStockData);
  }

  let stocksDataResult = await createSkuWiseStockMapForBatchId(stocksData);
  let stockBatchWiseMap = getBatchCodeQuantities(
    mergedSkuList,
    stocksDataResult
  );
  
  const stockBatchWiseEntries: Array<[string, [number, number, number]]> =
    [];
  stockBatchWiseMap.forEach((value, key) => {
    stockBatchWiseEntries.push([key, value]);
  });

  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};

  for (let i = 0; i < stockBatchWiseEntries.length; i++) {
    const [batchCode, quantities] = stockBatchWiseEntries[i];
    const product = products[batchCode];
    if (product) {
      const [avCs, avPi, avOth] = quantities;
      // Calculate normalized quantity based on product conversion factors
      const stockNormalizedQty =
        avCs * (product?.caseToPieceQuantity ?? 0) +
        avOth * (product?.otherUnitToPieceQuantity ?? 0) +
        avPi;

      // Store the normalized quantity for this batch code
      globalNormalizedStockMap.set(batchCode, {
        totalAvailableQuantity: stockNormalizedQty,
        totalOrderedQuantity: 0,

        mainAllocatedQuantity: 0,

        replacementQuantity: 0,

        allocatedReplacementQuantity: 0,

        remainingReplacementQuantity: 0,

        mainAllocatedByOrder: {},
        initialMainAllocatedByOrder: {},

        orderedQuantityByOrder: {},

        orders: [],
        replacementSku: [],

        replacementSkuAllocated: {},

        hasCompletedAllocation: false,
        allocationMethod: "FIFO",
      });
    }
  }

  return [
    globalNormalizedStockMap,
    stocksData
  ]
}

const updateReplacementQuantity = (globalNormalizedStockMap: Map<string, GlobalStockMapRecord>) => {
  globalNormalizedStockMap.forEach((prev, batchCode, map) => {
    if (!prev) return;
    //I can use prev.totalAvailableQuantity - prev.mainAllocatedQuantity for replacements elsewhere
    const newReplacementQuantity = prev.totalAvailableQuantity - prev.mainAllocatedQuantity 
    //Initially the remaining remaining replacement quantity which can be allocated will be total
    map.set(batchCode, { 
      ...prev, 
      replacementQuantity: newReplacementQuantity, 
      remainingReplacementQuantity: newReplacementQuantity, 
    });
  });
};


export const generateGlobalNormalizedStockMap = async (selectedOrders: any[], globalNormalizedStockMap: Map<string,GlobalStockMapRecord>, stocksData: any[], orderUomCheck: string): Promise<GlobalNormalizedStockMap> => {
  let outletData = await getOutletDetails();
  
  let allBatchCodesSet: Set<string> = new Set(); // Use a Set to store unique batch codes
  let batchCodeMap: OrderNumberBatchCodesMapType = {};
  let skuToMinExpiryDate: Record<string, SkuExpiryInfo> = {}
  
  for (const ro of selectedOrders) {
    const orderedBatchCodes: string =
    getBatchCodesWithoutFreeItem(ro["orderDetails"] ?? "") ?? "";
    const orderNumber = ro.orderNumber;
    batchCodeMap[orderNumber] = orderedBatchCodes;
    
    // Split batch codes and add to the Set to ensure uniqueness
    const codesArray = orderedBatchCodes
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
    codesArray.forEach((code) => allBatchCodesSet.add(code));
  }
  
  const { skuToReplacementSkuMap, replacementSkuList } =
      await getSkuToReplacementSkuMap(Array.from(allBatchCodesSet));
  
  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};

  skuToMinExpiryDate = getSkuToMinExpiryBatch(stocksData);
  globalNormalizedStockMap.forEach((curr, skuCode) => {
    const expiryInfo = skuToMinExpiryDate[skuCode];
    if (!expiryInfo) return;

    globalNormalizedStockMap.set(skuCode, {
      ...curr,
      minExpiryDate: expiryInfo.minExpiryDate,
      batchWithMinExpiry: expiryInfo.batchId,
    });
  });

  
  const skuToNameCodeMap = getSkuToNameCodeMap(products, Array.from(globalNormalizedStockMap.keys()));
  globalNormalizedStockMap.forEach((curr, skuCode) => {
    const skuInfo = skuToNameCodeMap[skuCode];
    if (!skuInfo) return;

    globalNormalizedStockMap.set(skuCode, {
      ...curr,
      skuCode: skuInfo.skuCode,
      skuName: skuInfo.skuName
    });
  });

  if (skuToReplacementSkuMap) {
    Object.keys(skuToReplacementSkuMap).forEach((sku) => {
      skuToReplacementSkuMap[sku].sort((a, b) => {
        const dateA = skuToMinExpiryDate[a]?.minExpiryDate?.getTime() ?? Infinity;
        const dateB = skuToMinExpiryDate[b]?.minExpiryDate?.getTime() ?? Infinity;
        return dateA - dateB;
      });
    });
  }

  // First, let's calculate normalized quantities for the stockBatchWiseMap

  // Preprocess the stock data to include normalized quantities

  //Create a stock map of each sku in orders and their replacement

  //iterate through the orders and allocate the ordered quantity without replacement
  
  //create a map of order to sku with stock exceeding
  //Fulfill the stock exceeding with replacement skus for each order

  const orderToStockExceedingSku: Record<string, Record<string, number>> = {};
  const initialAvailableMap = new Map<string, number>();

  globalNormalizedStockMap.forEach((record, batchCode) => {
    const available = Number(record?.totalAvailableQuantity ?? 0);
    initialAvailableMap.set(batchCode, available);
  });
  for (const ro of selectedOrders.sort(
      (a, b) =>
        new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
  ))  {
      if (!orderToStockExceedingSku[String(ro.id)]) {
        orderToStockExceedingSku[String(ro.id)] = {};
      }
      for (const roo of ro["orderDetails"]) {
        let caseOQ = roo?.caseQuantity ?? 0;
        let pieceOQ = roo?.pieceQuantity ?? 0;
        let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
        let batchCode = roo?.batchCode ?? "";
        const isFreeItem = roo?.type === "freeItem";
        if (isFreeItem) continue;

        let product = products[batchCode];

        let orderDetailsNQ: number;
        let stockNQ: number;

        // Determine normalized order quantity
        if (product) {
          orderDetailsNQ =
            roo?.normalizedQuantity ??
            caseOQ * (product?.caseToPieceQuantity ?? 0) +
              otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
              pieceOQ;
          stockNQ = globalNormalizedStockMap.get(batchCode)?.totalAvailableQuantity ?? 0;
        } else {
          continue
        }

        if (!orderToStockExceedingSku[ro.id][batchCode]){
          orderToStockExceedingSku[String(ro.id)][batchCode] = 0;
        }
          
        if (orderDetailsNQ <= stockNQ) {
          if (product) {
            if (globalNormalizedStockMap.has(batchCode)){
              const prev = globalNormalizedStockMap.get(batchCode)

              const mainAllocatedByOrder = prev?.mainAllocatedByOrder ?? {}
              if (mainAllocatedByOrder[ro.id]){
                mainAllocatedByOrder[ro.id] += orderDetailsNQ
              } else{
                mainAllocatedByOrder[ro.id] = orderDetailsNQ
              }

              const orderedQuantityByOrder = prev?.orderedQuantityByOrder ?? {}
              if (orderedQuantityByOrder[ro.id]){
                orderedQuantityByOrder[ro.id] += orderDetailsNQ
              } else{
                orderedQuantityByOrder[ro.id] = orderDetailsNQ
              }

              const orders = prev?.orders ?? []
              orders.push(ro)
              
              globalNormalizedStockMap.set(batchCode, 
                {
                  ...prev,
                  totalAvailableQuantity: (prev?.totalAvailableQuantity ?? 0) - orderDetailsNQ, 
                  totalOrderedQuantity: (prev?.totalOrderedQuantity ?? 0) + orderDetailsNQ,

                  mainAllocatedQuantity: (prev?.mainAllocatedQuantity ?? 0) + orderDetailsNQ,

                  replacementQuantity: prev?.replacementQuantity ?? 0,

                  allocatedReplacementQuantity: prev?.allocatedReplacementQuantity ?? 0,

                  remainingReplacementQuantity: prev?.remainingReplacementQuantity ?? 0,

                  mainAllocatedByOrder: mainAllocatedByOrder,
                  initialMainAllocatedByOrder: mainAllocatedByOrder,

                  orderedQuantityByOrder: orderedQuantityByOrder,

                  orders: orders, 
                  replacementSku: skuToReplacementSkuMap[batchCode],

                  replacementSkuAllocated: prev?.replacementSkuAllocated ?? {},
                }
              );
            }
          } 

          orderToStockExceedingSku[String(ro.id)][batchCode] = 0

        } else {
          orderToStockExceedingSku[String(ro.id)][batchCode] = orderDetailsNQ - stockNQ

          if (product) {
            if (globalNormalizedStockMap.has(batchCode)){
              const prev = globalNormalizedStockMap.get(batchCode)

              const mainAllocatedByOrder = prev?.mainAllocatedByOrder ?? {}
              if (mainAllocatedByOrder[ro.id]){
                mainAllocatedByOrder[ro.id] += stockNQ
              } else{
                mainAllocatedByOrder[ro.id] = stockNQ
              }

              const orders = prev?.orders ?? []
              orders.push(ro)

              const orderedQuantityByOrder = prev?.orderedQuantityByOrder ?? {}
              if (orderedQuantityByOrder[ro.id]){
                orderedQuantityByOrder[ro.id] += orderDetailsNQ
              } else{
                orderedQuantityByOrder[ro.id] = orderDetailsNQ
              }

              globalNormalizedStockMap.set(batchCode, 
                {
                  ...prev,
                  totalAvailableQuantity: (prev?.totalAvailableQuantity ?? 0) - stockNQ,
                  totalOrderedQuantity: (prev?.totalOrderedQuantity ?? 0) + orderDetailsNQ,

                  mainAllocatedQuantity: (prev?.mainAllocatedQuantity ?? 0) + stockNQ,

                  replacementQuantity: prev?.replacementQuantity ?? 0,

                  allocatedReplacementQuantity: prev?.allocatedReplacementQuantity ?? 0,

                  remainingReplacementQuantity: prev?.remainingReplacementQuantity ?? 0,

                  mainAllocatedByOrder: mainAllocatedByOrder,
                  initialMainAllocatedByOrder: mainAllocatedByOrder,
                  orderedQuantityByOrder: orderedQuantityByOrder,

                  orders: orders, 
                  replacementSku: skuToReplacementSkuMap[batchCode],

                  replacementSkuAllocated: prev?.replacementSkuAllocated ?? {},
                }
              );
            }
          } else {
            continue
          }
        }

      }
    }
  initialAvailableMap.forEach((initialQty, batchCode) => {
    const prev = globalNormalizedStockMap.get(batchCode);
    if (!prev) return;
    globalNormalizedStockMap.set(batchCode, {
      ...prev,
      totalAvailableQuantity: initialQty,
    });
  });
  //After fifo allocation without replacement update replacement quantity
  updateReplacementQuantity(globalNormalizedStockMap)
  addOutletInfo(selectedOrders, globalNormalizedStockMap, outletData)

  orderToStockExceedingSku &&
  Object.entries(orderToStockExceedingSku).forEach(([orderId, orderDetail]) => {
    Object.entries(orderDetail).forEach(([batchCode, stockExceedingQuantity]) => {
      const replSkuList = skuToReplacementSkuMap[batchCode] || [];

      // Get current SKU record safely
      const currentSku = globalNormalizedStockMap.get(batchCode);
      if (!currentSku) return;

      // Clone replacementSkuAllocated to avoid mutating shared reference
      const currentOrder: Record<string, number> = { ...currentSku.replacementSkuAllocated[orderId] } ;

      for (const repl of replSkuList) {
        if (stockExceedingQuantity <= 0) break;

        const replRecord = globalNormalizedStockMap.get(repl);
        if (!replRecord) continue

        const replStock = replRecord?.remainingReplacementQuantity ?? 0;
        if (replStock <= 0) continue;

        const allocate = Math.min(replStock, stockExceedingQuantity);

        // Update global stock for the replacement SKU
        globalNormalizedStockMap.set(repl, {
          ...replRecord!,
          allocatedReplacementQuantity: (replRecord?.allocatedReplacementQuantity ?? 0) + allocate,
          remainingReplacementQuantity: (replRecord?.remainingReplacementQuantity ?? 0) - allocate,
          // keep initialAllocatedReplacementQuantity unchanged if it's meant to track initial allocation
        });

        // Update order-specific replacement allocation
        currentOrder[repl] = (currentOrder[repl] ?? 0) + allocate;

        // Deduct from exceeding quantity
        stockExceedingQuantity -= allocate;

        // Update aggregate bookkeeping
      }

      // Write back the updated replacement allocation to the batch record
      globalNormalizedStockMap.set(batchCode, {
        ...currentSku,
        replacementSkuAllocated: {
          ...currentSku.replacementSkuAllocated,
          [orderId]: currentOrder,
        },
      });

    });
  });

  const next = new Map(globalNormalizedStockMap); // clone
  next.forEach((rec, batchCode) => {
    const totalOrdered = Number(rec?.totalOrderedQuantity ?? 0);

    const mainAllocated = Object.values(rec?.mainAllocatedByOrder ?? {}).reduce(
      (s, v) => s + (Number(v) || 0),
      0
    );

    let replacementAllocated = 0;
    const replByOrder = rec?.replacementSkuAllocated ?? {};
    for (const perOrder of Object.values(replByOrder)) {
      if (!perOrder) continue;
      for (const qty of Object.values(perOrder as Record<string, number>)) {
        replacementAllocated += Number(qty || 0);
      }
    }

    const allocatedSum = mainAllocated + replacementAllocated;
    const oversold = Math.max(totalOrdered - allocatedSum, 0);

    const cloned: GlobalStockMapRecord = {
      ...rec,
      oversoldQuantity: oversold,
    };

    next.set(batchCode, cloned);
  });

  globalNormalizedStockMap = next; // assign back to your variable

  //update the allocated quantity for each sku and allocate the remaining stock exceeding quantity from replacement stock and deduct the stock of replacement
  //udpate the stock exceeding quantity for each sku
  //update the orderDetails for each sku with new initialFifoTotalAllocatedQuantity

  //Above logic will first allocate sku ordered quantity with their available stock
  //then allocate the remaining quantity with stock of replacement
  //At the end we will get
  //
  // for each sku a map which contains:
  // allocated quantity = min(orderedQuantity, available stock of sku) + min(remainingOrderedQuantity, stock of all replacement sku)
  // We have to go through all the replacments by expiry and deduct their stock
  // To perform stock deduction

  // availablequantity = available stock of sku + available stock of all replacements 
  // stock exceeding quantity = max(availablequantity - allocatedquantity, 0)
  return globalNormalizedStockMap;
};

export interface OrderWiseAllocationData {
  id: string;
  orderNumber: string;
  outletName: string;
  outletCode: string;
  isKeyAccount: boolean;
  orderDate: string;
  skuCode: string;
  batchCode: string;

  totalOrderedQuantity: number;
  orderedCases: number;
  orderedPieces: number;
  orderedOthers: number;

  totalAllocatedQuantity: number;
  allocatedCases: number;
  allocatedPieces: number;
  allocatedOthers: number;

  totalStockExceedingQuantity: number;
  stockExceedingCases: number;
  stockExceedingPieces: number;
  stockExceedingOthers: number;

  initialTotalStockExceedingQuantity: number;
  initialStockExceedingCases: number;
  initialStockExceedingPieces: number;
  initialStockExceedingOthers: number;

  mainAllocatedCases: number;
  mainAllocatedPieces: number;
  mainAllocatedOthers: number;
  initialMainAllocatedCases: number;
  initialMainAllocatedOthers: number;
  initialMainAllocatedPieces: number;

  replacementAllocated: Record<string, number>;
  initialReplacementAllocated: Record<string, number>;

  uom: string;
  otherUnitName: string;
  caseToPieceQty: number;
  otherToPieceQty: number;
  
  initialTotalAllocatedQuantity: number,
  initialAllocatedCases: number,
  initialAllocatedPieces: number,
  initialAllocatedOthers: number,
  creditLimit?:number;
  creditAvailable?:number;
  showMultipleRows?: boolean;
  mergedRows?: any;
  initialMergedRows?: any;
}

export const generateMergedRows = (currentSku: string, allocatedBreakdownForCurrentSku : {cs: number, pi: number, oth: number}, replacementAllocated: Record<string, number>, products: any, orderUomCheck: string ) => {
  const mergedRows: any = {};

  const currentProduct = products[currentSku]; 
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");

  let caseUnitLabel = ConfigDictionary?.caseUnitLabel;
  let otherUnitLabel = ConfigDictionary?.otherUnitLabel;
  let packUnitLabel = ConfigDictionary?.packUnitLabel;
  const { displayOtherUnitName, } = ConfigDictionary;

  let customOtherUnitLabel = displayOtherUnitName ? currentProduct?.otherUnitName && currentProduct?.otherUnitName.length > 0
    ? currentProduct?.otherUnitName
    : otherUnitLabel
  : otherUnitLabel;

  otherUnitLabel = customOtherUnitLabel

  mergedRows.skuCode = currentSku;
  mergedRows.skuDescription = currentProduct?.skuDescription ?? ""
  mergedRows.allocatedQuantity= allocatedBreakdownForCurrentSku.cs * (currentProduct?.caseToPieceQuantity ?? 0) + allocatedBreakdownForCurrentSku.oth * (currentProduct?.otherUnitToPieceQuantity ?? 0) + allocatedBreakdownForCurrentSku.pi
  mergedRows.allocatedCases= allocatedBreakdownForCurrentSku.cs
  mergedRows.allocatedPieces= allocatedBreakdownForCurrentSku.pi
  mergedRows.allocatedOthers= allocatedBreakdownForCurrentSku.oth
  mergedRows.caseUnitLabel = caseUnitLabel
  mergedRows.otherUnitLabel = otherUnitLabel
  mergedRows.packUnitLabel = packUnitLabel

  const replacements: any[] = []

  for (const replSku in replacementAllocated) {
    const qty = replacementAllocated[replSku] ?? 0;
    const {cs, pi, oth} = addToUomWiseAllocation(products[replSku], qty, orderUomCheck);
    let caseUnitLabel = ConfigDictionary?.caseUnitLabel;
    let otherUnitLabel = ConfigDictionary?.otherUnitLabel;
    let packUnitLabel = ConfigDictionary?.packUnitLabel;
    const { displayOtherUnitName, } = ConfigDictionary;

    let customOtherUnitLabel = displayOtherUnitName ? products[replSku]?.otherUnitName && products[replSku]?.otherUnitName.length > 0
      ? products[replSku]?.otherUnitName
      : otherUnitLabel
    : otherUnitLabel;

    otherUnitLabel = customOtherUnitLabel

    replacements.push({
      skuCode: replSku,
      skuDescription: products[replSku]?.skuDescription ?? "",
      allocatedQuantity: qty,
      allocatedCases: cs,
      allocatedPieces: pi,
      allocatedOthers: oth,
      caseUnitLabel: caseUnitLabel,
      otherUnitLabel: otherUnitLabel,
      packUnitLabel: packUnitLabel,
    })
  }

  mergedRows.replacements = replacements

  return mergedRows;
}


export const generateOrderWiseAllocationData = async (
  orders: any[],
  globalNormalizedStockMap: GlobalNormalizedStockMap,
  batchCode: string,
  orderUomCheck: string,
  outletList: OutletInfo[]
): Promise<OrderWiseAllocationData[]> => {
  const result: OrderWiseAllocationData[] = [];

  //fetchOutlet's credit Data
  const outletCodeList = outletList.map((outlet) => outlet.outletCode)
  const outletCreditMap = await getOutletCreditMap(outletCodeList)

  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};
  
  const isManualForBatch = (order: any) => {
    const od = (order.orderDetails ?? []).find(
      (i: any) => i.batchCode === batchCode && i.type !== "freeItem"
    );
    return !!od && !!od.hasBeenManuallyAllocated;
  };

  const getCreationTs = (order: any) => {
    const t = order?.creationTime;
    const v = t ? new Date(t).getTime() : 0;
    return Number.isFinite(v) ? v : 0;
  };

  const globalStockRecord = globalNormalizedStockMap.get(batchCode);

  const sortedOrders = [...orders].sort((a, b) => {
    const aManual = isManualForBatch(a) ? 1 : 0;
    const bManual = isManualForBatch(b) ? 1 : 0;

    // manual orders first
    if (aManual !== bManual) return bManual - aManual;

    // then by creationTime ascending
    return getCreationTs(a) - getCreationTs(b);
  });

  for (const order of sortedOrders.sort(
    (a, b) =>
      new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
  )) {
    const roo = (order.orderDetails ?? []).find(
      (i: any) => i.batchCode === batchCode && i.type !== "freeItem"
    );
    if (!roo) continue;

    const orderedQuantity = globalStockRecord?.orderedQuantityByOrder[order.id] ?? 0;

    const mainAllocatedQuantity = globalStockRecord?.mainAllocatedByOrder[order.id] ?? 0;

    const replacementAllocated: Record<string, number> =
      globalStockRecord?.replacementSkuAllocated?.[order.id] ?? {};

    const totalReplacementAllocated = Object.values(replacementAllocated ?? {}).reduce(
      (sum, qty) => sum + (Number(qty) || 0),
      0
    );

    const allocatedBreakdownForCurrentSku = addToUomWiseAllocation(
      products[batchCode],
      mainAllocatedQuantity,
      orderUomCheck
    );
    // Total allocated = main + replacement
    const totalAllocated = mainAllocatedQuantity + totalReplacementAllocated;

    const stockExceedingQuantity = Math.max(orderedQuantity - totalAllocated, 0);

    const orderedBreakdown = addToUomWiseAllocation(products[batchCode], orderedQuantity, orderUomCheck);

    const exceedingBreakdown = addToUomWiseAllocation(products[batchCode], stockExceedingQuantity, orderUomCheck);

    const allocatedBreakdown = addToUomWiseAllocation(products[batchCode], totalAllocated, orderUomCheck)

    const mergedRows = generateMergedRows(batchCode, allocatedBreakdownForCurrentSku, replacementAllocated, products, orderUomCheck);

    result.push({
      id: order.id,
      orderNumber: order.orderNumber,
      outletName: order.outletName,
      outletCode: order.outletCode,
      orderDate: order.creationTime,
      skuCode: batchCode,
      batchCode: batchCode,
      totalOrderedQuantity: orderedQuantity,
      orderedCases: orderedBreakdown.cs,
      orderedPieces: orderedBreakdown.pi,
      orderedOthers: orderedBreakdown.oth,

      totalAllocatedQuantity: totalAllocated,
      allocatedCases: allocatedBreakdown.cs,
      allocatedPieces: allocatedBreakdown.pi,
      allocatedOthers: allocatedBreakdown.oth,

      // Track main and replacement allocations separately
      mainAllocatedCases: allocatedBreakdownForCurrentSku.cs,
      mainAllocatedPieces: allocatedBreakdownForCurrentSku.pi,
      mainAllocatedOthers: allocatedBreakdownForCurrentSku.oth,
      replacementAllocated, // <-- per-SKU allocation map

      initialMainAllocatedCases: allocatedBreakdownForCurrentSku.cs,
      initialMainAllocatedOthers: allocatedBreakdownForCurrentSku.oth,
      initialMainAllocatedPieces: allocatedBreakdownForCurrentSku.pi,
      initialReplacementAllocated: replacementAllocated,

      initialTotalAllocatedQuantity: totalAllocated,
      initialAllocatedCases: allocatedBreakdown.cs,
      initialAllocatedPieces: allocatedBreakdown.pi,
      initialAllocatedOthers: allocatedBreakdown.oth,

      totalStockExceedingQuantity: stockExceedingQuantity,
      stockExceedingCases: exceedingBreakdown.cs,
      stockExceedingPieces: exceedingBreakdown.pi,
      stockExceedingOthers: exceedingBreakdown.oth,

      initialStockExceedingCases: exceedingBreakdown.cs,
      initialStockExceedingOthers: exceedingBreakdown.oth,
      initialStockExceedingPieces: exceedingBreakdown.pi,
      initialTotalStockExceedingQuantity: stockExceedingQuantity,

      uom: orderUomCheck === "true" ? (products[batchCode]?.uom ?? "") : "all",
      otherUnitName: products[batchCode]?.otherUnitName,
      caseToPieceQty: products[batchCode]?.caseToPieceQuantity ?? 99999,
      otherToPieceQty: products[batchCode]?.otherUnitToPieceQuantity ?? 99999,
      creditAvailable: outletCreditMap[order.outletCode]?.creditAvailable ?? 0,
      creditLimit: outletCreditMap[order.outletCode]?.creditLimit ?? 0,
      isKeyAccount: outletList.find((item) => item.outletCode === order.outletCode)?.isKeyAccount ?? false,
      showMultipleRows: true,
      mergedRows: mergedRows,
      initialMergedRows: mergedRows,
    });
  }

  return result;
};
export const getOrderBodyForPayload = (orders: any[]) => {
  const listOfOrderNumbersNotAllocatedByUser = orders.map((order) => order.orderNumber);
  return {
    auto: [...listOfOrderNumbersNotAllocatedByUser],
    manual: []
  };
};

export interface OrderBodyForPayloadMap {
  [orderNumber: string]: {
    orderNumber: string;
    outletName?:string;
    outletCode?:string;
    creationTime?:string;
    orderDetails: Record<
      string,
      {
        batchCode: string;
        skuCode: string;
        caseQuantity: number;
        pieceQuantity: number;
        otherUnitQuantity: number;
        hasBeenManuallyAllocated?: boolean;
        allocatedCases?: number;
        allocatedPieces?: number;
        allocatedOthers?: number;
        type?: string;
        replacements?: Record<string, { cs: number; pi: number; oth: number }>;
      }
    >;
  };
}


export const generateOrderBodyByBatchMap = (orders: any[]): OrderBodyForPayloadMap => {
  const result: OrderBodyForPayloadMap = {};

  orders.forEach((order) => {
    const orderDetailsByBatch: Record<string, any> = {};

    (order.orderDetails || [])
      .filter((od: any) => od.type !== "freeItem") // remove freeItems upfront
      .forEach((od: any) => {
        orderDetailsByBatch[od.batchCode] = {
          type: od.type ?? 'normal',
          batchCode: od.batchCode,
          skuCode: od.batchCode, // replace with actual SKU if available
          caseQuantity: od.caseQuantity || 0,
          pieceQuantity: od.pieceQuantity || 0,
          otherUnitQuantity: od.otherUnitQuantity || 0,
        };
      });

    result[order.orderNumber] = {
      orderNumber: order.orderNumber,
      outletCode: order.outletCode,
      outletName: order.outletName,
      orderDetails: orderDetailsByBatch,
      creationTime: order.creationTime,
    };
  });

  return result;
};



export const fetchStockDataForOrders = async (orders: any[]) => {
  let allBatchCodesSet: Set<string> = new Set();
  let batchCodeMap: Record<string, string> = {};

  for (const ro of orders) {
    const orderDetails = ro.orderDetails;
    if (!orderDetails || Object.keys(orderDetails).length === 0) continue;

    // Collect batch codes from orderDetails (Record<string, ...>)
    const orderedBatchCodes: string =
      getBatchCodesWithoutFreeItem(Object.values(orderDetails)) ?? "";
    const orderNumber = ro.orderNumber;
    batchCodeMap[orderNumber] = orderedBatchCodes;

    const codesArray = orderedBatchCodes
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
    codesArray.forEach((code) => allBatchCodesSet.add(code));
  }

  const stockBatchWiseMap = new Map<string, [number, number, number]>();
  const normalizedStockMap = new Map<string, number>();

  if (allBatchCodesSet.size === 0) {
    return { stockBatchWiseMap, normalizedStockMap };
  }

  const allBatchCodesArray = Array.from(allBatchCodesSet);
  const BATCH_SIZE = 100;
  let stocksData: any[] = [];

  for (let i = 0; i < allBatchCodesArray.length; i += BATCH_SIZE) {
    const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE).join(",");
    const chunkStockData = await fetchBatchDataForSkuList(chunk, getQuantityType());
    stocksData = stocksData.concat(chunkStockData);
  }

  const stocksDataResult = await createSkuWiseStockMapForBatchId(stocksData);

  getBatchCodeQuantities(allBatchCodesArray.join(","), stocksDataResult).forEach((value, key) => {
    stockBatchWiseMap.set(key, value);
  });

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { uomConversion } = ConfigDictionary;

  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};

  if (uomConversion) {
    stockBatchWiseMap.forEach((quantities, batchCode) => {
      const product = products[batchCode];
      if (!product) return;

      const [avCs, avPi, avOth] = quantities;
      const stockNormalizedQty =
        avCs * (product.caseToPieceQuantity ?? 0) +
        avOth * (product.otherUnitToPieceQuantity ?? 0) +
        avPi;

      normalizedStockMap.set(batchCode, stockNormalizedQty);
    });
  }

  return { stockBatchWiseMap, normalizedStockMap };
};


export const handleBulkInvoicingAfterManualAllocation = async (orderPayload:  {auto: [], manual: []}) => {
  const res = await sendBulkInvoicingAfterManualAllocation(orderPayload)
  return res;
}




type CreditInfo = {
  creditLimit: number;
  creditAvailable: number;
  creditStatus: string;
};

export async function getOutletCreditMap(outletList: string[]) {
  const res = await getCreditData(outletList);
  const features = res.data.features;

  const outletCreditMap: Record<string, CreditInfo> = {};

  features.forEach((feature: any) => {
    outletCreditMap[feature.outletCode] = {
      creditLimit: feature.creditLimit,
      creditAvailable: feature.creditAvailable,
      creditStatus: feature.creditStatus,
    };
  });

  return outletCreditMap;
}

export const addToUomWiseAllocation = (product: any, normalizedQty: number, orderUomCheck: string) => {
  if (!product || normalizedQty === 0) return { cs: 0, pi: 0, oth: 0 };
  let { caseToPieceQuantity, otherUnitToPieceQuantity, uom, otherUnitName } = product;
  if (orderUomCheck === "true") uom = product?.uom ?? "all";
  else uom = "all";

  const { convertedCaseQty, convertedOtherQty, convertedPieceQty } =
    performUomConversion(
      0,
      0,
      normalizedQty,
      uom,
      caseToPieceQuantity,
      otherUnitToPieceQuantity,
      0,
      0,
      0,
      true,
      otherUnitName
    );

  return { cs: convertedCaseQty, pi: convertedPieceQty, oth: convertedOtherQty };
};

const verifyStock = async (manualOrders: any, payload: any): Promise<boolean> => {
  const url = `${EnvironmentRegistry.getStockBaseUrl()}/consolidatedStock/bulkSecondaryOrderUpdate?action=VALIDATE`
  const res = await ChannelkartNetworkPut(
    url,
    payload
  );

  let allBatchCodesSet: Set<string> = new Set();
  for (const ro of manualOrders) {
    const orderedBatchCodes: string =
    getBatchCodesWithoutFreeItem(ro["orderDetails"] ?? "") ?? "";
    const codesArray = orderedBatchCodes
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);
    codesArray.forEach((code) => allBatchCodesSet.add(code));
  }
  console.log(res);

  const skuToPartialMap: Record<string, boolean> = {};
  const stockRes = res.data["stockResponses"] ?? [];

  for (const summary of stockRes) {
    for (const skuSummary of summary["updateSummaries"]) {
      if (allBatchCodesSet.has(skuSummary?.skuCode)){
        if (skuSummary?.partial === true) {
          skuToPartialMap[skuSummary.skuCode] = true;
        }
      }
    }
  }
  const hasPartial = Object.values(skuToPartialMap).some((isPartial) => isPartial);
  return !hasPartial;
};


export const checkAllocation = async (orderBodyForPayload: any) => {
  const manualOrders = orderBodyForPayload.manual;
  if (manualOrders.length === 0) return true

  const payload: any[] = [];

  for (const order of manualOrders) {
    // ✅ define the object shape explicitly or use `any`
    const newOrderBody: any = {};

    newOrderBody.orderId = order.orderNumber;
    newOrderBody.supplier = JSON.parse(localStorage.authContext).user.loginId;
    newOrderBody.revertDetails = []

    newOrderBody.skuDetails = order.orderDetails.map((orderDetail: any) => ({
      skuCode: orderDetail.batchCode,
      pieceQty: orderDetail.pieceQuantity,
      caseQty: orderDetail.caseQuantity,
      otherQty: orderDetail.otherUnitQuantity,
      type: "normal",
    }));

    payload.push(newOrderBody);
  }
  const isValid = await verifyStock(manualOrders, payload)
  return isValid
};

export const verifyAllocation = async (orderBodyForPayload: any) => {
  const canAllocate = await checkAllocation(orderBodyForPayload);
  if (!canAllocate) throw new Error("Cannot allocate orders");
};